import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import Button from '../../../../common/components/Button/Button';
import { Modal } from 'react-bootstrap';
import { ButtonBar } from '../../../../common/components';
import { actions as customerActions } from '../../redux/customerActions';
import { hasPermission } from '../../../auth/redux/authActions';
const TITLE = 'Anonymize Customer';

const Content = ({
  canAnonymize,
  customerName,
  onCoverPolicies,
  allPolicies,
  allPolicyApplications,
}) => {
  const hasOnCoverPolicies = !!onCoverPolicies.length;

  if (!canAnonymize) {
    return <p>{customerName} cannot be anonymized because they have policies.</p>;
  }

  if (!hasOnCoverPolicies) {
    return (
      <>
        <p> Are you sure you want to anonymize {customerName}?</p>
        <p>The below policies and all their travellers will be anonymized</p>

        {allPolicies && (
          <>
            <p>Policies</p>

            <ul>
              {allPolicies.map((policy) => (
                <li>{policy?.attributes?.policy_number}</li>
              ))}
            </ul>
          </>
        )}

        <p>Policy Applications</p>
        <ul>
          {allPolicyApplications.map((policyApplication) => (
            <li>{policyApplication?.attributes?.quote_reference}</li>
          ))}
        </ul>
      </>
    );
  }

  return (
    <>
      <p>
        {customerName} cannot be anonymized because they have at least one active policy.
      </p>
      <p>Please cancel the below policies to continue with anonymization</p>

      <ul>
        {onCoverPolicies.map((policy) => (
          <li>{policy?.attributes?.policy_number}</li>
        ))}
      </ul>
    </>
  );
};

const AnonymizeCustomerButton = ({
  customerId,
  customerName,
  onCoverPolicies,
  allPolicies,
  allPolicyApplications,
  anonymizeCustomer,
  getCustomer,
}) => {
  const [showModal, setShowModal] = useState(false);

  const { isSubmitting } = useSelector((state) => state.customer);

  const handleOpen = () => {
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };

  const nonCancelledPolicies = allPolicies.find(
    (policy) => policy.attributes.status !== 'cancelled',
  );

  const hasExpiredPolicies = nonCancelledPolicies > onCoverPolicies;

  const canAnonymize = hasExpiredPolicies
    ? hasPermission('policy.underwriter')
    : !onCoverPolicies.length;

  const handleAnonymizeCustomer = () => {
    return Promise.resolve(anonymizeCustomer(customerId)).then(() => {
      getCustomer(customerId, ['policies', 'policy_applications']);
      handleClose();
    });
  };

  return (
    <>
      <Button
        bsStyle="primary"
        className={'pull-right'}
        label={TITLE}
        handleClick={handleOpen}
      />
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{TITLE}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Content
            canAnonymize={canAnonymize}
            onCoverPolicies={onCoverPolicies}
            allPolicies={allPolicies}
            allPolicyApplications={allPolicyApplications}
            customerName={customerName}
          />
        </Modal.Body>
        <Modal.Footer>
          <ButtonBar>
            {canAnonymize && (
              <Button
                bsStyle="primary"
                className={'pull-right'}
                label={TITLE}
                handleClick={handleAnonymizeCustomer}
                isLoading={isSubmitting}
              />
            )}
            <Button
              bsStyle="default"
              className={'pull-right'}
              label={'Close'}
              handleClick={handleClose}
              isLoading={isSubmitting}
            />
          </ButtonBar>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default connect(
  null,
  {
    anonymizeCustomer: customerActions.anonymizeCustomer,
    getCustomer: customerActions.getCustomer,
  },
)(AnonymizeCustomerButton);
